<template>
  <div class="panoramic" v-show="panoramicShow">
    <div id="container2">
      <img src="@/assets/image/zoom.png" @click.prevent.self="doShrink" v-show="!enlargeShow">
      <img src="@/assets/image/zoom-open.png" @click.prevent.self="doEnlarge" v-show="enlargeShow">
    </div>
  </div>
</template>

<script>
import {
  Stage,
  FloorModel,
  PerspectiveView,
  OrthographicView,
  AerialElementController,
  THREE,
  EventHub,
  Events,
  PanoramaGroup,
  PanoramaController,
  AlignmentUtils,
  PathGroup,
  IndicatorDisplayMode,
} from '@aibee/owlly';
import { eventHub as eventHubPro } from '@aibee/vincent';
import { listPanoramas, adjustPanorama, getListPanoAdjus } from '@/api/map';
import panoramicInfo from '@/components/mapComponents/panoramicInfo.vue';

export default {
  name: 'panoramicAlone',
  computed: {
    source() {
      return this.$route.params.source;
    },
  },
  props: {
    panoramaImages: {
      type: Array,
    },
  },
  data() {
    return {
      stage: null,
      panoramaController: null,
      panoramaGroup: null,
      panorama: null,
      list: [],
      model_path: '',
      initial_view: {},
      groundExpression: [0, 0, 1, 0.9],
      handlePid: 0,
      handleSeqId: 0,
      enlargeShow: true,
      sliderFlag: false,
      panoramicShow: true,
      direction: [],
      x: 0,
      y: 0,
      z: 0,
      panoramasData: null,
    };
  },
  mounted() {
    // if (this.$route.query.floor_id) this.getListPanoramas();
    eventHubPro.$on('LoadPanoramas', (data) => {
      this.getListPanoramas(data);
    });
    eventHubPro.$on('ReloadPathGroup', (data) => {
      this.reloadPathGroup(data);
    });
  },
  watch: {
    list: {
      handler(val) {
        this.init();
      },
    },
    panoramaImages: {
      handler(val) {
        this.panorama.updateTexture(val);
      },
      deep: true,
    },
  },
  methods: {
    async getListPanoramas(data) {
      if (data && data.model_path && data.panorama_list) {
        this.list = data.panorama_list.filter(t => t.visible);
        this.model_path = data.model_path;
        this.initial_view = data.initial_view;
        this.groundExpression = data.ground_expression;
        this.panoramasData = data;
      } else {
        let res = null;
        try {
          res = await this.loadListPanoramas();
        } catch(e) {
          this.$message.error('获取全景数据出错');
        }
        if (res && res.data && res.data.data) {
          if (!res.data.data.panorama_list) { 
            this.panoramicShow = false; return;
          }
          this.list = res.data.data.panorama_list.filter(t => t.visible);
          this.model_path = res.data.data.model_path;
          this.initial_view = res.data.data.initial_view;
          this.groundExpression = res.data.data.ground_expression;
          this.panoramasData = res.data.data;
        }
      }
    },
    async loadListPanoramas(type) {
      if (!this.$route.query.vr_id) {
        return this.$message.warning('获取全景数据需要先在对应的楼层填写vr_id');
      }
      return listPanoramas(this.$route.query.vr_id);
    },
    async init() {
      this.stage = new Stage(); // 初始化场景
      const container2 = document.getElementById('container2');
      // 测试用
      // this.stage.setStatsEnabled(true); // 开启帧率统计显示
      // this.stage.setAxesEnabled(true); // 开启坐标轴显示
      // 楼层模型
      const model = new FloorModel(this.model_path);
      this.floorModel = model;
      this.stage.bindElement(model); // 绑定一下, 几乎所有东西都要绑定一次到stage
      if (container2) {
        const view2 = new PerspectiveView(container2); // 全景视图, 正常投影
        // 初始化一个有一个全景图的全景图组
        this.panoramaGroup = new PanoramaGroup(this.list.map(p => ({
          // pid: p.id,
          pid: p.seq_id,
          textureURLs: p.panorama_images_low,
          neighbourPanoramaIDs: p.visible_panorama_seq_ids,
          position: new THREE.Vector3(p.coordinate.position_x, p.coordinate.position_y, p.coordinate.position_z),
          quaternion: new THREE.Quaternion(p.coordinate.direction_x, p.coordinate.direction_y, p.coordinate.direction_z, p.coordinate.direction_w),
        })), {
          modelElement: model,
          visibleRadius: 1000,
        }, true);
        // 全景图控制器, 可以用鼠标在全景图视图里面用鼠标转
        this.panoramaController = new PanoramaController(view2, this.panoramaGroup, model);
        // stage各种绑定一下
        // this.stage.bindView(view);
        this.stage.bindView(view2);
        this.stage.bindElement(this.panoramaGroup);
        this.stage.bindController(this.panoramaController);
        // 切换点位
        this.panoramaController.setMouseClickEnabled(true);
        // 注册事件, 返回全景点位id
        // EventHub.on(Events.PANORAMA_SELECTED, (pid) => {
        //   console.log(
        //     'panorama selected',
        //     pid,
        //   );
        //   this.handleSeqId = pid;
        //   this.handlePid = this.list.find(item => item.seq_id === pid).id;
        //   const idx = this.list.findIndex(item => item.seq_id === pid);
        //   this.direction = [this.list[idx].coordinate.direction_x, this.list[idx].coordinate.direction_y, this.list[idx].coordinate.direction_z, this.list[idx].coordinate.direction_w];
        //   this.panorama = await this.panoramaGroup.getPanoramaByPID(this.handleSeqId); // 拿一个全景图
        //   this.panoramaController.lookFromPanorama(this.handleSeqId, new THREE.Vector3(
        //     this.initial_view.roaming_direction_x,
        //     this.initial_view.roaming_direction_y,
        //     this.initial_view.roaming_direction_z,
        //   ));
        //   this.panoramaController.setMouseClickEnabled(true);
        // });
        // 注册前清除事件
        try {
          EventHub.remove(Events.PANORAMA_SELECTED, this.onPanoSelect);
        // eslint-disable-next-line no-empty
        } catch (error) {}
        // 注册事件, 返回全景点位id
        EventHub.on(Events.PANORAMA_SELECTED, this.onPanoSelect);
        this.panoramaGroup.addGroupViewConfiguration({
          targetView: view2,
          indicatorDisplayMode: IndicatorDisplayMode.Editing,
          showIndicators: true,
        });
        // controller.bindElement(panoramas);
        this.handlePid = this.list[0].id;
        this.handleSeqId = this.list[0].seq_id;
        this.direction = [this.list[0].coordinate.direction_x, this.list[0].coordinate.direction_y, this.list[0].coordinate.direction_z, this.list[0].coordinate.direction_w];
        this.panorama = await this.panoramaGroup.getPanoramaByPID(this.handleSeqId); // 拿一个全景图
        // 调用一次渲染全景图
        this.panoramaController.lookFromPanorama(this.handleSeqId, new THREE.Vector3(
          this.initial_view.roaming_direction_x,
          this.initial_view.roaming_direction_y,
          this.initial_view.roaming_direction_z,
        ));
        // 加入路径渲染
        const paths = new PathGroup();
        this.stage.bindElement(paths);
        this.paths = paths;
        // 重新载入新路线组
        // paths.load([
        //   [
        //     { x: 23.51465606689453, y: 29.97823143005371, z: 0.55 },
        //     { x: 23.926475524902344, y: 29.09889030456543, z: 0.55 },
        //     { x: 14.904803276062012, y: 29.88187599182129, z: 0.55 },
        //   ],
        // ]);

        // this.panorama.setAdditionalRotationInEuler(0, Math.PI / 18, 0); // 返回 Quaternion {x: 0, y: 0.08715574274765817, z: 0, w: 0.9961946980917455}
        // // 初始化时设置全景图的旋转
        // this.panorama.setAdditionalRotationInQuaternion(0, 0.08715574274765817, 0, 0.9961946980917455); // 返回 Euler {x: -0, y: 0.17453292519943295 === Math.PI / 18, z: -0}
        // const euler = this.panorama.setAdditionalRotationInQuaternion(...this.direction);
        // controller.bindElement(this.panorama); // 全景图绑定到AerialElementController
        // this.stage.bindController(controller); // 将AerialElementController绑定到stage
        // console.log(this.panorama.setAdditionalRotationInEuler(0, Math.PI / 18, 0));
        // console.log(this.panorama.setAdditionalRotationInQuaternion(0, 0.08715574274765817, 0, 0.9961946980917455));
        this.stage.forceResize();
        // 弧度转角度
        // this.x = euler.x * (180 / Math.PI);
        // this.y = euler.y * (180 / Math.PI);
        // this.z = euler.z * (180 / Math.PI);
        // this.$refs.panoramicInfo.x = this.x;
        // this.$refs.panoramicInfo.y = this.y;
        // this.$refs.panoramicInfo.z = this.z;
      }
    },
    async onPanoSelect(pid) {
      console.log(
        'onPanoSelect panorama selected',
        pid,
      );
      this.handleSeqId = pid;
      this.handlePid = this.list.find(item => item.seq_id === pid).id;
      const idx = this.list.findIndex(item => item.seq_id === pid);
      this.direction = [this.list[idx].coordinate.direction_x, this.list[idx].coordinate.direction_y, this.list[idx].coordinate.direction_z, this.list[idx].coordinate.direction_w];
      this.panorama = await this.panoramaGroup.getPanoramaByPID(this.handleSeqId); // 拿一个全景图
      // getListPanoAdjus(this.$route.query.floor_id, { task_type: 1 }).then((res) => {
      //   const adjustmentInfo = res.data.data.adjustment_info;
      //   if (Object.keys(adjustmentInfo).includes(this.handlePid.toString())) {
      //     this.panorama.setAdditionalRotationInEuler(
      //       // 角度转弧度
      //       adjustmentInfo[this.handlePid].offset_x * (Math.PI / 180),
      //       adjustmentInfo[this.handlePid].offset_y * (Math.PI / 180),
      //       adjustmentInfo[this.handlePid].offset_z * (Math.PI / 180),
      //     );
      //   }
      this.panoramaController.moveToPanorama(this.handleSeqId, { fadeInOut: true });
      // });
      this.panoramaController.setMouseClickEnabled(true);
    },
    doShrink() {
      this.enlargeShow = true;
      this.$emit('panoramicAloneResize', this.enlargeShow);
      this.$nextTick(() => {
        this.stage.forceResize();
      });
    },
    doEnlarge() {
      this.enlargeShow = false;
      this.$emit('panoramicAloneResize', this.enlargeShow);
      this.$nextTick(() => {
        this.stage.forceResize();
      });
    },
    // 重新加载路径 [[{x,y,z}],[...],...]
    reloadPathGroup(data) {
      const options = {
        floorModel: this.floorModel,
      };
      if (this.groundExpression.length >= 4) {
        const groundPlane = {
          a: this.groundExpression[0] || 0,
          b: this.groundExpression[1] || 0,
          c: this.groundExpression[2] || 1,
          d: this.groundExpression[3] || 0.9,
        };
        options.groundParams = { downDirection: new THREE.Vector3(0, 0, -1), groundPlane };
      }
      this.paths.load(data.filter(t => t.length > 1), options);
    },
  },
};
</script>
<style lang='less' scoped>
.panoramic{
  display: flex;
  background-color: #1b1b1b;
  height: 100%;
}
#container, #container2{
    width: 100%;
    // height: 480px;
    height: 98%;
    background-color: #fff;
    position: relative;
    border-radius: 8px;
    margin: 0 10px;
    overflow: hidden;
    img{
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 9;
      cursor: pointer;
    }
}
</style>
